import { BetType } from './tableNumbers';

const OvalTablePathEnumsRight = [
  {
    value: 0,
    data: BetType.StraightUp_0,
    width: '41.599',
    height: '39.384',
    gId: 'Group_34705',
    pathId: 'Path_57912',
    fill: 'url(#greenGrad) #00622E',
    gDataName: 'Group 34705',
    pathDataName: 'Path 57912',
    viewBox: '0 0 41.599 39.384',
    gTransform: 'translate(-1051.62 -512.814)',
    pathTransform: 'translate(1092.573 513.455) rotate(90)',
    d: 'M14.14,40.2,38.068,22.251A57.679,57.679,0,0,0,10.372,0L0,27.646A27.6,27.6,0,0,1,14.14,40.2Z',
  },
  {
    value: 32,
    data: BetType.StraightUp_32,
    width: '36.63',
    height: '34.49',
    gId: 'Group_34706',
    pathId: 'Path_57917',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34706',
    pathDataName: 'Path 57917',
    viewBox: '0 0 36.63 34.49',
    gTransform: 'translate(-1034.311 -527.01)',
    pathTransform: 'translate(1070.222 527.655) rotate(90)',
    d: 'M0,17.954A27.652,27.652,0,0,1,3.4,31.029v4.382H33.346V31.524A57.218,57.218,0,0,0,23.927,0Z',
  },
];

const OvalTablePathEnumsLeft = [
  {
    value: 30,
    data: BetType.StraightUp_30,
    width: '34.754',
    height: '34.165',
    gId: 'Group_34726',
    pathId: 'Path_57916',
    fill: 'url(#redGrad) #9E0000',
    pathDataName: 'Path 57916',
    viewBox: '0 0 34.754 34.165',
    firstGDataName: 'Group 34726',
    gTransform: 'translate(-689.804 -527.336)',
    pathTransform: 'translate(724.058 527.993) rotate(90)',
    d: 'M3.059,0V6.161A27.064,27.064,0,0,1,0,18.433L25.719,33.564A57.233,57.233,0,0,0,33.008,5.546V0Z',
  },
  {
    value: 8,
    data: BetType.StraightUp_8,
    width: '36.696',
    height: '37.31',
    pathId: 'Path_57920',
    gId: 'Group_34727',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34727',
    pathDataName: 'Path 57920',
    viewBox: '0 0 36.696 37.31',
    gTransform: 'translate(-669.631 -517.078)',
    pathTransform: 'translate(705.625 517.793) rotate(90)',
    d: 'M0,11.087,17.058,35.313A57.772,57.772,0,0,0,35.919,15.131L10.2,0A27.612,27.612,0,0,1,0,11.087Z',
  },
  {
    value: 23,
    data: BetType.StraightUp_23,
    width: '34.688',
    height: '31.242',
    gId: 'Group_34728',
    pathId: 'Path_57913',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34728',
    pathDataName: 'Path 57913',
    viewBox: '0 0 34.688 31.242',
    gTransform: 'translate(-660.522 -504.315)',
    pathTransform: 'translate(694.538 504.815) rotate(90)',
    d: 'M0,4.013V33.5a57.217,57.217,0,0,0,30.035-9.279L12.978,0A27.356,27.356,0,0,1,0,4.013Z',
  },
  {
    value: 10,
    data: BetType.StraightUp_10,
    width: '33.485',
    height: '32.501',
    gId: 'Group_34729',
    pathId: 'Path_57918',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34729',
    pathDataName: 'Path 57918',
    viewBox: '0 0 33.485 32.501',
    gTransform: 'translate(-660.5 -472.815)',
    pathTransform: 'translate(693.351 473.541) rotate(90)',
    d: 'M29.889,2.861A27.39,27.39,0,0,1,17.674,0L0,23.944a57.243,57.243,0,0,0,29.949,8.407c.443,0,.883-.023,1.325-.033V2.826C30.815,2.848,30.354,2.861,29.889,2.861Z',
  },
  {
    value: 5,
    data: BetType.StraightUp_5,
    width: '37.121',
    height: '38.446',
    gId: 'Group_34730',
    pathId: 'Path_57914',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34730',
    pathDataName: 'Path 57914',
    viewBox: '0 0 37.121 38.446',
    gTransform: 'translate(-668.742 -453.526)',
    pathTransform: 'translate(705.145 454.203) rotate(90)',
    d: 'M24.911,0,0,16.278A57.81,57.81,0,0,0,19.338,35.737L37.012,11.793A27.6,27.6,0,0,1,24.911,0Z',
  },
  {
    value: 24,
    data: BetType.StraightUp_24,
    width: '36.394',
    height: '34.29',
    gId: 'Group_34731',
    pathId: 'Path_57921',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34731',
    pathDataName: 'Path 57921',
    viewBox: '0 0 36.394 34.29',
    gTransform: 'translate(-688.164 -445.478)',
    pathTransform: 'translate(724.058 445.978) rotate(90)',
    d: 'M29.949,6.065V0H0V5.546A57.252,57.252,0,0,0,8.224,35.192L33.135,18.914A27.369,27.369,0,0,1,29.949,6.065Z',
  },
];

const OvalTableRectEnumsBottom = [
  {
    value: 15,
    data: BetType.StraightUp_15,
    gId: 'Group_34707',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34707',
    rectId: 'Rectangle_12875',
    rectDataName: 'Rectangle 12875',
    gTransform: 'translate(-1010.407 -530.552)',
    rectTransform: 'translate(1034.811 531.052) rotate(90)',
  },
  {
    value: 19,
    data: BetType.StraightUp_19,
    gId: 'Group_34708',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34708',
    rectId: 'Rectangle_12876',
    rectDataName: 'Rectangle 12876',
    gTransform: 'translate(-986.503 -530.552)',
    rectTransform: 'translate(1010.908 531.052) rotate(90)',
  },
  {
    value: 4,
    data: BetType.StraightUp_4,
    gId: 'Group_34709',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34709',
    rectId: 'Rectangle_12798',
    rectDataName: 'Rectangle 12798',
    gTransform: 'translate(-962.599 -530.552)',
    rectTransform: 'translate(987.003 531.052) rotate(90)',
  },
  {
    value: 21,
    data: BetType.StraightUp_21,
    gId: 'Group_34710',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34710',
    rectId: 'Rectangle_12786',
    rectDataName: 'Rectangle 12786',
    gTransform: 'translate(-938.695 -530.552)',
    rectTransform: 'translate(963.099 531.052) rotate(90)',
  },
  {
    value: 2,
    data: BetType.StraightUp_2,
    gId: 'Group_34711',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34711',
    rectId: 'Rectangle_12799',
    rectDataName: 'Rectangle 12799',
    gTransform: 'translate(-914.791 -530.552)',
    rectTransform: 'translate(939.195 531.052) rotate(90)',
  },
  {
    value: 25,
    data: BetType.StraightUp_25,
    gId: 'Group_34712',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34712',
    rectId: 'Rectangle_12787',
    rectDataName: 'Rectangle 12787',
    gTransform: 'translate(-890.886 -530.552)',
    rectTransform: 'translate(915.291 531.052) rotate(90)',
  },
  {
    value: 17,
    data: BetType.StraightUp_17,
    gId: 'Group_34713',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34713',
    rectId: 'Rectangle_12800',
    rectDataName: 'Rectangle 12800',
    gTransform: 'translate(-866.983 -530.552)',
    rectTransform: 'translate(891.387 531.052) rotate(90)',
  },
  {
    value: 34,
    data: BetType.StraightUp_34,
    gId: 'Group_34714',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
  {
    value: 6,
    data: BetType.StraightUp_6,
    gId: 'Group_34715',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34715',
    rectId: 'Rectangle_12801',
    rectDataName: 'Rectangle 12801',
    gTransform: 'translate(-819.175 -530.552)',
    rectTransform: 'translate(843.579 531.052) rotate(90)',
  },
  {
    value: 27,
    data: BetType.StraightUp_27,
    gId: 'Group_34722',
    fill: 'url(#redGrad) #9E0000',
    property: 'Group 34722',
    rectId: 'Rectangle_12789',
    rectDataName: 'Rectangle 12789',
    gTransform: 'translate(-795.27 -530.552)',
    rectTransform: 'translate(819.674 531.052) rotate(90)',
  },
  {
    value: 13,
    data: BetType.StraightUp_13,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 36,
    data: BetType.StraightUp_36,
    gId: 'Group_34714',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
  {
    value: 11,
    data: BetType.StraightUp_11,
    gId: 'Group_34725',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34725',
    rectId: 'Rectangle_12803',
    rectDataName: 'Rectangle 12803',
    gTransform: 'translate(-723.558 -530.552)',
    rectTransform: 'translate(747.962 531.052) rotate(90)',
  },
];

const OvalTableRectEnumsTop = [
  {
    value: 16,
    data: BetType.StraightUp_16,
    gId: 'Group_34722',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34722',
    rectId: 'Rectangle_12789',
    rectDataName: 'Rectangle 12789',
    gTransform: 'translate(-795.27 -530.552)',
    rectTransform: 'translate(819.674 531.052) rotate(90)',
  },
  {
    value: 33,
    data: BetType.StraightUp_33,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 1,
    data: BetType.StraightUp_1,
    gId: 'Group_34714',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
  {
    value: 20,
    data: BetType.StraightUp_20,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 14,
    data: BetType.StraightUp_14,
    gId: 'Group_34722',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34722',
    rectId: 'Rectangle_12789',
    rectDataName: 'Rectangle 12789',
    gTransform: 'translate(-795.27 -530.552)',
    rectTransform: 'translate(819.674 531.052) rotate(90)',
  },
  {
    value: 31,
    data: BetType.StraightUp_31,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 9,
    data: BetType.StraightUp_9,
    gId: 'Group_34714',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
  {
    value: 22,
    data: BetType.StraightUp_22,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 18,
    data: BetType.StraightUp_18,
    gId: 'Group_34722',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34722',
    rectId: 'Rectangle_12789',
    rectDataName: 'Rectangle 12789',
    gTransform: 'translate(-795.27 -530.552)',
    rectTransform: 'translate(819.674 531.052) rotate(90)',
  },
  {
    value: 29,
    data: BetType.StraightUp_29,
    gId: 'Group_34723',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 7,
    data: BetType.StraightUp_7,
    gId: 'Group_34723',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34723',
    rectId: 'Rectangle_12802',
    rectDataName: 'Rectangle 12802',
    gTransform: 'translate(-771.366 -530.552)',
    rectTransform: 'translate(795.771 531.052) rotate(90)',
  },
  {
    value: 28,
    data: BetType.StraightUp_28,
    gId: 'Group_34714',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
  {
    value: 12,
    data: BetType.StraightUp_12,
    gId: 'Group_34714',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34714',
    rectId: 'Rectangle_12788',
    rectDataName: 'Rectangle 12788',
    gTransform: 'translate(-843.078 -530.552)',
    rectTransform: 'translate(867.482 531.052) rotate(90)',
  },
];

const OvalTableRectEnums_35_26 = [
  {
    value: 35,
    data: BetType.StraightUp_35,
    width: '37.454',
    height: '34.29',
    gId: 'Group_34745',
    pathId: 'Path_57919',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34745',
    pathDataName: 'Path 57919',
    viewBox: '0 0 37.454 34.29',
    gTransform: 'translate(-1034.311 -445.479)',
    pathTransform: 'translate(1071.033 445.979) rotate(90)',
    d: 'M29.949,31.792A27.387,27.387,0,0,1,33.155,18.9L9.95,0A57.232,57.232,0,0,0,0,32.335v3.887H29.949Z',
  },
  {
    value: 3,
    data: BetType.StraightUp_3,
    width: '42.479',
    height: '39.45',
    gId: 'Group_34746',
    pathId: 'Path_57915',
    fill: 'url(#redGrad) #9E0000',
    gDataName: 'Group 34746',
    pathDataName: 'Path 57915',
    viewBox: '0 0 42.479 39.45',
    gTransform: 'translate(-1051.36 -455.257)',
    pathTransform: 'translate(1093.203 455.929) rotate(90)',
    d: 'M38.156,28.09,29.214,0A57.645,57.645,0,0,0,0,22.17l23.205,18.9A27.6,27.6,0,0,1,38.156,28.09Z',
  },

  {
    value: 26,
    data: BetType.StraightUp_26,
    width: '32.534',
    height: '40.012',
    gId: 'Group_34747',
    pathId: 'Path_57922',
    fill: 'url(#blackGrad) #121212',
    gDataName: 'Group 34747',
    pathDataName: 'Path 57922',
    viewBox: '0 0 32.534 40.012',
    gTransform: 'translate(-1064.175 -484.518)',
    pathTransform: 'translate(1096.209 485.143) rotate(90)',
    d: 'M8.941,31.1a27.537,27.537,0,0,1,19.431.286L38.744,3.735A57.523,57.523,0,0,0,0,3.006Z',
  },
];

export {
  OvalTableRectEnumsTop,
  OvalTablePathEnumsLeft,
  OvalTablePathEnumsRight,
  OvalTableRectEnumsBottom,
  OvalTableRectEnums_35_26,
};
